import { IfitApiClient } from '@ifit/ifit-api-v1';
let client;
const version = 'v1';

export function createClient(baseUrl, token, clientId, clientSecret) {
  client = new IfitApiClient(`${baseUrl}/${version}/`, token, clientId, clientSecret);
}

export default function getClient() {
  return client;
}


// WEBPACK FOOTER //
// ./src/client.js